import React from 'react';

const AppContext = React.createContext(() => ({ mode: 'yote' }));
export const { Provider, Consumer } = AppContext;
export default AppContext;
